import {MenuGroup} from "./MenuGroup";
import {PartitionLite} from "../partition/PartitionLite";
import {PushNotificationInfo} from "./PushNotificationInfo";

export class PostLoginUser {
  id!: number;
  /**
   * Username of logged partitionUser
   */
  username!: string;
  email!: string;
  /**
   * First Name of logged partitionUser
   */
  firstname!: string;
  /**
   * Last Name of logged partitionUser
   */
  lastname!: string;
  /**
   * Language of logged partitionUser
   */
  language?: string;
  /**
   * Roles of logged partitionUser
   */
  roles?: string[];
  /**
   * List of menuItems items
   */
  menuItems!: MenuGroup[];
  /**
   * Partition type
   */
  partition!: PartitionLite;

  pushNotificationInfo!: PushNotificationInfo;
}
